import request from '@utils/request';
/**
 * 场馆列表
 * @param {*} q
 * @returns
 */
export function getVenueList(q) {
    return request.get('venue/lists', q, { login: false });
}
/**
 * 场馆详情
 * @param {*} id
 * @returns
 */
export function getVenueInfo(id) {
    return request.get('venue/info/' + id, {}, { login: false });
}
/**
 * 场馆预约
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function reserveVenue(id, data) {
    return request.post('venue/submit/' + id, data);
}
/**
 * 查询日期是否被预约
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function venueReserve(id, data) {
    return request.get('venue/reserve/' + id, data, { login: false });
}
